import http from "../http/http-config";
import { QuotationProcessResult } from "../models/quotationProcessResult";

export default new class SaveEmissionService {
    HealthSaveEmission(model: string): Promise<QuotationProcessResult> {
        return http.post<QuotationProcessResult>("SaveEmission/HealthSaveEmission", model).then(response => response.data);
    }
    TheftSaveEmission(model: string): Promise<QuotationProcessResult> {
        return http.post<QuotationProcessResult>("SaveEmission/TheftSaveEmission", model).then(response => response.data);
    }
    TheftElectronicDeviceSaveEmission(model: string): Promise<QuotationProcessResult> {
        return http.post<QuotationProcessResult>("SaveEmission/TheftElectronicDeviceSaveEmission", model).then(response => response.data);
    }

    FamilyCombinedPremiumSaveEmission(model: string): Promise<QuotationProcessResult> {
        return http.post<QuotationProcessResult>("SaveEmission/FamilyCombinedPremiumSaveEmission", model).then(response => response.data);
    }

    APSaveEmission(model: string): Promise<QuotationProcessResult> {
        return http.post<QuotationProcessResult>("SaveEmission/APSaveEmission", model).then(response => response.data);
    }

    TravelAssistanceSaveEmission(model: string): Promise<QuotationProcessResult> {
        return http.post<QuotationProcessResult>("SaveEmission/TravelAssistanceSaveEmission", model).then(response => response.data);
    }
}